import React from 'react';
import { FadeIn, CtaButton } from './ui';
const STEPS = [{
  num: '1️⃣',
  title: 'Escribís por WhatsApp',
  desc: 'Un mensaje es suficiente. En segundos coordinamos tu sesión.'
}, {
  num: '2️⃣',
  title: 'Elegís tu horario',
  desc: '¿Ahora mismo o después? Vos manejás los tiempos.'
}, {
  num: '3️⃣',
  title: 'Completás el pago',
  desc: 'Rápido y seguro. $10.000 ARS por sesión completa.'
}, {
  num: '4️⃣',
  title: 'Hablás con Valentín',
  desc: '45 minutos para vos. Sin interrupciones. Sin apuro.'
}];
export function HowItWorks() {
  return <section className="w-full bg-[#213354] px-6 py-20 sm:py-28" data-id="element-63">
      <div className="mx-auto max-w-6xl" data-id="element-64">
        <FadeIn className="text-center" data-id="element-65">
          <h2 className="font-serif text-3xl text-white sm:text-4xl" data-id="element-66">
            Empezar es más fácil de lo que pensás.
          </h2>
        </FadeIn>

        <div className="relative mt-14" data-id="element-67">
          <div className="absolute left-8 top-0 hidden h-full w-px bg-[#8BA3C7]/25 lg:left-0 lg:top-7 lg:h-px lg:w-full lg:block" aria-hidden="true" data-id="element-68" />
          <div className="grid gap-10 lg:grid-cols-4" data-id="element-69">
            {STEPS.map((step, i) => <FadeIn key={step.title} delay={i * 0.1} data-id="element-70">
                <div className="relative flex flex-col items-center text-center" data-id="element-71">
                  <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#8BA3C7]/40 bg-[#1B2B4A] text-2xl" data-id="element-72">
                    {step.num}
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-white" data-id="element-73">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-xs leading-relaxed text-white/70" data-id="element-74">
                    {step.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn className="mt-14 flex justify-center" data-id="element-75">
          <CtaButton variant="primary" data-id="element-76">Empezar ahora →</CtaButton>
        </FadeIn>
      </div>
    </section>;
}